// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.paymentTerms', {
    url: '/paymentterms',
    templateUrl: 'main/configuration/paymentTerms/paymentTerms.tpl.html',
    data: { pageTitle: 'Payment terms' },
  });
};

angular.module('configuration.paymentTerms', []).config(config);
